import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'

@Component({
  selector: 'app-document-signer-notifications',
  templateUrl: './document-signer-notifications.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DocumentSignerNotificationsComponent {
  @Input() form: UntypedFormGroup
}
